import {Card, CardActions, CardContent, CardHeader, Dialog, DialogContent, Divider, Grid, Stack,} from "@mui/material";
import React, {Fragment, useEffect, useState} from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import StepNavigationButtons from "../components/StepNavigationButtons";
import {useNavigate} from "react-router-dom";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import toast from "react-hot-toast";
import SuretiesDetailDialogForm from "./components/components-sureties-data/SuretiesDetailDialogForm";
import SuretiesDataDetailTable from "./components/components-sureties-data/SuretiesDataDetailTable";
import {AddressFormData} from "./components/components-company-data/DialogAddress";
import DeleteDialog from "../../../components/dialog/DeleteDialog";
import {HttpSolicitation, HttpSolicitationClient} from "../../../http/solicitation/httpSolicitation";
import {Client, ClientFields, ClientRelationshipInsertFields} from "../../../types/client/clientData";
import {LoaderBlockUI} from "../../../components/loader";
import {HttpClient} from "../../../http/client/httpClient";
import {SolicitationClient, SolicitationClientFields} from "../../../types/solicitation/solicitationData";
import CompanyCuitSyncDialogContent
    from "../../../@core/layouts/components/horizontal/app-bar-content/CompanyCuitSyncDialogContent";
import BaseDialogTitle from "../../../components/dialog/BaseDialogTitle";
import {ClientRelationshipClassificationCodes} from "../../../types/client/clientEnums";
import {HttpSolicitationOnboarding} from "../../../http/solicitation/httpSolicitationOnboarding";
import {MiddleStepProps} from "../index";




export enum SolicitationClientFormDataFields {
    Participation = 'porcParticipacion',
    Address = 'direccion',
    FianceCuit = 'cuitConyugue',
    FianceName = 'razonSocialConyugue',
}

export type SolicitationClientFormData = {
    [ClientFields.CUIT]: string;
    [ClientFields.BusinessName]: string;
    [ClientFields.IdentificationNumber]: string;
    [ClientFields.BirthDate]: Date;
    [ClientFields.GenderCode]: number;
    [ClientFields.MaritalStatusCode]: number;
    [ClientFields.AfipResponsibilityTypeCode]: number;
    [ClientFields.ClientClassificationCode]: number;
    [SolicitationClientFormDataFields.Participation]: number;
    [ClientRelationshipInsertFields.RelationshipTypeCode]?: number;
    [SolicitationClientFormDataFields.Address]?: AddressFormData;
    [SolicitationClientFormDataFields.FianceCuit]?: string;
    [SolicitationClientFormDataFields.FianceName]?: string;
}

const StepSuretiesData = ({ handleNext, handlePrev, clientSolicitationId }: MiddleStepProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const navigate = useNavigate()
    const [client, setClient] = useState<Client>()
    const [cuitCompleted, setCuitCompleted] = useState<boolean>(false)
    const [clientSolicitations, setClientSolicitations] = useState<SolicitationClient[]>()
    const [loading, setLoading] = useState<boolean>(false)
    const [clientToEdit, setClientToEdit] = useState<SolicitationClient | undefined>(undefined)
    const [clientRelatedId, setClientRelatedId] = useState<number>(0)
    const [openDelete, setOpenDelete] = useState<boolean>(false)
    
    const loadClientSolicitations = () => {
        setLoading(true)
        HttpSolicitation.getClientRelatedsByIdSolicitation(clientSolicitationId).then((r) => {
            setClientSolicitations(r.filter((x) => x[SolicitationClientFields.RelationshipClassificationCode]  === ClientRelationshipClassificationCodes.MoreSureties))
            setLoading(false)
        })
    }
    
    useEffect(() => {
        loadClientSolicitations()
    }, [clientSolicitationId])
    
    useEffect(() => {
        if(clientToEdit && !client) {
            setCuitCompleted(true)
            setLoading(true)
            HttpClient.getById(clientToEdit[SolicitationClientFields.ClientId]).then((r) => {
                setClient(r)
                setLoading(false)
            })
        }
    }, [clientToEdit])
    
    const onEdit = (solicitationClient: SolicitationClient) => {
        setClientToEdit(solicitationClient)
        setOpen(true)
    }
    
    const onDelete = () => {
        setLoading(true)
        HttpSolicitationClient.deleteClientRelated(clientSolicitationId, clientRelatedId).then(() => {
            setLoading(false)
            loadClientSolicitations()
        }).catch(() => {
            toast.error("Ocurrió un error al eliminar cliente")
        }).finally(() => {
            setLoading(false)
        })
    }
    
    const onDeleteClientRelated = (id: number) => {
        setClientRelatedId(id)
        setOpenDelete(true)
    }
    
    const onHandleNext = () => {
        HttpSolicitationOnboarding.getStepResult(clientSolicitationId, 2)
            .then((r) => {
                if (!r.tieneError) handleNext()
                else {
                    toast.error(r.descripcionError)
                }
            })
    }
    
    const onCloseDialog = () => {
        setOpen(false)
        setClient(undefined)
        setClientToEdit(undefined)
        setCuitCompleted(false)
    }
    
    return (
        <Card>
            <CardHeader
                title={"Datos de los fiadores"}
                action={
                <Stack direction="row" alignItems={'center'} spacing={2}>
                    <Button
                        color='primary'
                        variant='contained'
                        onClick={() => { setOpen(true) }}
                        startIcon={<AddIcon />}
                    >
                        Nuevo
                    </Button>
                    <Button color='secondary' variant='contained' onClick={() => navigate('/solicitudes')} startIcon={<KeyboardBackspaceOutlinedIcon/>}>
                        Inicio
                    </Button>
                </Stack>
                }
            />
            <Divider />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <SuretiesDataDetailTable sureties={clientSolicitations} onEdit={onEdit} onDelete={onDeleteClientRelated}/>
                    </Grid>
                </Grid>
                <Dialog open={open} onClose={onCloseDialog} maxWidth={'md'} fullWidth>
                    <BaseDialogTitle title={clientToEdit ? 'Editar fiador/a' : 'Nuevo fiador/a'} onClose={onCloseDialog} />
                    <Divider />
                    <DialogContent>
                            {
                                !cuitCompleted ?
                                    <Fragment>
                                        {
                                            !client && !clientToEdit &&
                                            <CompanyCuitSyncDialogContent subtitle={'Ingrese un CUIT para sincronizar los datos con AFIP y agilizar la operación'}
                                                                          onSave={(client: Client) => {
                                                                              setCuitCompleted(true)
                                                                              setClient(client)
                                                                          }}
                                            />
                                        }
                                    </Fragment>
                                    :
                                    <Grid container justifyContent={'center'} spacing={4}>
                                        {
                                            client &&
                                            <SuretiesDetailDialogForm client={client}
                                                                      onFinishSave={() => {
                                                                          loadClientSolicitations()
                                                                          onCloseDialog()
                                                                      }}
                                                                      onBack={() => {
                                                                          setCuitCompleted(false)
                                                                          setClient(undefined)
                                                                          setClientToEdit(undefined)
                                                                      }}
                                                                      solicitationId={clientSolicitationId}
                                                                      clientToEdit={clientToEdit}
                                            />
                                        }
                                    </Grid>
                            }
                    </DialogContent>
                </Dialog>
            </CardContent>
            <CardActions>
                <StepNavigationButtons handleNext={onHandleNext} handlePrev={handlePrev} />
            </CardActions>
            <DeleteDialog open={openDelete}
                          onClose={() => {setOpenDelete(false)}}
                          onDelete={onDelete}
                          title={'Eliminar fiador'}
                          description={'¿Está seguro de eliminar el fiador?'}
            />
            {loading && <LoaderBlockUI/>}
        </Card>
    )
}


export default StepSuretiesData